import styled from '@emotion/styled'
import * as v from '../../../../../variables/styles'

export const PHCont = styled.div((props)=>({
  display:'flex',
  flex:1,
}))

export const Cont = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))

export const ContDetail = styled.div((props)=>({
  display:'flex',
  marginTop:'1rem',

  '>div:first-child':{
    flex:1,
    display:'flex',
    justifyContent:'end',
    paddingRight:'1rem',
    fontWeight:'bold'
  },
  '>div:last-child':{
    flex:2
  },

  '.fileList':{
    flex:2,
    display:'flex',
    flexDirection:'column',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignItems:'flex-start',

    '.button':{
      width:'30rem',
      display:'flex',
      marginTop:'0.2rem'
    },

    '.fileName':{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }
  }

}))
